// Чистая логика доп. услуг (T11). Без DOM — под юнит-тесты. Каталог приходит из GET /api/services
// уже нормализованным: { id, name, description, price (за единицу), perDay, chooseQuantity, maxCount }.
// Решения владельца (10.09.2026): посуточные услуги по умолчанию берутся на все ночи (D1),
// оплачиваются при заселении и в предоплату не входят (D3).
import { plural } from "./dates.js";
import { fmtRub } from "./money.js";

export const daysWord = (n) => plural(n, "сутки", "суток", "суток");

// количество по умолчанию: посуточная услуга с выбором количества — на все ночи, остальные — 1
export const defaultServiceCount = (svc, nights) =>
  svc.chooseQuantity && svc.perDay ? Math.max(1, nights) : 1;

// потолок количества: maxCount Шелтера, иначе две длины заезда для посуточных и 10 для прочих
// (зеркало serviceMaxCount в server/src/api/book.js — менять синхронно)
export const serviceMaxCount = (svc, nights) =>
  svc.maxCount ?? (svc.perDay ? Math.max(nights, 1) * 2 : 10);

// items: [{ price, count }] — Σ за выбранные услуги
export const servicesTotal = (items) =>
  (items ?? []).reduce((sum, i) => sum + (Number(i.price) || 0) * (Number(i.count) || 0), 0);

export function priceLabel(svc) {
  if (!svc.price) return "бесплатно";
  return svc.perDay ? `${fmtRub(svc.price)} за сутки` : fmtRub(svc.price);
}

// «3 000 ₽ × 5 суток» / «2 500 ₽ × 2»
export function formulaLabel(price, count, perDay) {
  return perDay ? `${fmtRub(price)} × ${count} ${daysWord(count)}` : `${fmtRub(price)} × ${count}`;
}
